/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SignatureAuthority } from './SignatureAuthority';
import {
    SignatureAuthorityFromJSON,
    SignatureAuthorityFromJSONTyped,
    SignatureAuthorityToJSON,
    SignatureAuthorityToJSONTyped,
} from './SignatureAuthority';

/**
 * 
 * @export
 * @interface SafeDepositBoxServiceRoleBulkItem
 */
export interface SafeDepositBoxServiceRoleBulkItem {
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxServiceRoleBulkItem
     */
    partnerUid: string;
    /**
     * Value selected from SafeDepositBoxServiceRoleOptions.safeRoles
     * @type {string}
     * @memberof SafeDepositBoxServiceRoleBulkItem
     */
    safeRole: string;
    /**
     * 
     * @type {SignatureAuthority}
     * @memberof SafeDepositBoxServiceRoleBulkItem
     */
    signatureAuthority: SignatureAuthority;
}



/**
 * Check if a given object implements the SafeDepositBoxServiceRoleBulkItem interface.
 */
export function instanceOfSafeDepositBoxServiceRoleBulkItem(value: object): value is SafeDepositBoxServiceRoleBulkItem {
    if (!('partnerUid' in value) || value['partnerUid'] === undefined) return false;
    if (!('safeRole' in value) || value['safeRole'] === undefined) return false;
    if (!('signatureAuthority' in value) || value['signatureAuthority'] === undefined) return false;
    return true;
}

export function SafeDepositBoxServiceRoleBulkItemFromJSON(json: any): SafeDepositBoxServiceRoleBulkItem {
    return SafeDepositBoxServiceRoleBulkItemFromJSONTyped(json, false);
}

export function SafeDepositBoxServiceRoleBulkItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxServiceRoleBulkItem {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerUid': json['partnerUid'],
        'safeRole': json['safeRole'],
        'signatureAuthority': SignatureAuthorityFromJSON(json['signatureAuthority']),
    };
}

export function SafeDepositBoxServiceRoleBulkItemToJSON(json: any): SafeDepositBoxServiceRoleBulkItem {
    return SafeDepositBoxServiceRoleBulkItemToJSONTyped(json, false);
}

export function SafeDepositBoxServiceRoleBulkItemToJSONTyped(value?: SafeDepositBoxServiceRoleBulkItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerUid': value['partnerUid'],
        'safeRole': value['safeRole'],
        'signatureAuthority': SignatureAuthorityToJSON(value['signatureAuthority']),
    };
}

